import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';

import "swiper/dist/css/swiper.min.css"
import "./assets/css/public.css"
import "./assets/css/style.css"

import wow from 'wowjs'
import 'animate.css'

// import AOS from "aos";
// import "../node_modules/aos/dist/aos.css";
// Vue.use(AOS);

Vue.use(ElementUI);
// Vue.prototype.$AOS = AOS
Vue.prototype.$wow = wow

// 引入dayjs
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'dGe0TeskRxCpRREAPESKWaGc9uKXXiMy'
})

// 全局id
Vue.prototype.webId = '92615279-afeb-13ee-bbf2-d63a5bd2c2b7'
Vue.prototype.webIdEn = '0e198820-9353-4908-a4c8-f7a1134af8d1'
    // Vue.prototype.webIdGroup = 'BEE8AB69-65E3-4161-ACF7-0E09E4028BB8'

// 引入vue-i18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'zh-CN', // 语言标识
    messages: {
        'zh-CN': require('./lang/zh'), // 通过require引入中文语言包
        'en-US': require('./lang/en') // 通过require引入英文语言包
    }
})

// Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')